import type { Workspace } from '../types';

const COPY = {
  sponsored: {
    eyebrow: 'CWI / SPONSORED PROGRAMS',
    title: 'Program operations',
    body: 'Enrollment, delivery, progress, and privacy-safe outcomes for your sponsored programs.',
    cards: [
      ['Programs', 'Program setup and assignments arrive in PR2.'],
      ['Cohorts', 'Cohort operations and rosters arrive in PR2.'],
      ['Reporting', 'All outcome queries will enforce k=5 before values reach the browser.'],
    ],
  },
  creator: {
    eyebrow: 'CREATOR PARTNER PROGRAM',
    title: 'Creator partnership',
    body: 'Referral tools, community impact, transparent revenue, and payout history.',
    cards: [
      ['Referral tools', 'Primary code, link, and QR arrive in PR3.'],
      ['Earnings', 'Stored gross-to-net ledger values arrive in PR3.'],
      ['Privacy', 'Creator access remains limited to its own partner ID.'],
    ],
  },
  admin: {
    eyebrow: 'STAKD ADMINISTRATION',
    title: 'Platform operations',
    body: 'Global management and financial controls for allow-listed STAKD staff.',
    cards: [
      ['Security gate', 'Global writes terminate at audited staff-gated Edge Functions.'],
      ['Creator operations', 'Partner and payout administration arrive in PR4.'],
      ['Credential boundary', 'The browser is built with the public anon key only.'],
    ],
  },
} as const;

export function WorkspaceHome({ workspace }: { workspace: Workspace }) {
  const copy = COPY[workspace.kind];
  return (
    <div className="page-grid">
      <section className="hero-panel">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h1>{copy.title}</h1>
        <p>{copy.body}</p>
      </section>
      <section className="foundation-grid" aria-label="Foundation status">
        {copy.cards.map(([title, body]) => <article className="panel" key={title}><h2>{title}</h2><p>{body}</p></article>)}
      </section>
      <section className="panel trust-panel">
        <div className="privacy-five">5</div>
        <div>
          <p className="eyebrow">REPORTING MINIMUM</p>
          <h2>Held back, on purpose</h2>
          <p>Aggregate results under five participants are suppressed in the database query and every export path. The browser never receives held-back values.</p>
        </div>
      </section>
    </div>
  );
}
